import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { Provider } from "react-redux";
import axios from "axios";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import common_en from "./Locales/en/translation.json";
import common_sr from "./Locales/sr/translation.json";
import common_de from "./Locales/de/translation.json";
import store from "./utils/redux/store";

// Attach auth token + inject loggedUserId into request body for mutating requests
axios.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("user");
    if (raw) {
      const user = JSON.parse(raw);
      config.headers = config.headers || {};
      if (user?.accessToken) config.headers["x-access-token"] = user.accessToken;

      const method = (config.method || "").toLowerCase();
      if (user?.id && ["post", "put", "patch", "delete"].includes(method)) {
        if (config.data && typeof config.data === "object" && !(config.data instanceof FormData)) {
          config.data = { ...config.data, loggedUserId: user.id };
        } else if (!config.data) {
          config.data = { loggedUserId: user.id };
        }
      }
    }
  } catch {
    // malformed localStorage entry — skip
  }
  return config;
});

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: common_en },
      sr: { translation: common_sr },
      de: { translation: common_de },
    },
    fallbackLng: "sr",
    interpolation: {
      escapeValue: false,
    },
  });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <I18nextProvider i18n={i18next}>
    <React.StrictMode>
      <Router>
        <Provider store={store}>
          <App />
        </Provider>
      </Router>
    </React.StrictMode>
  </I18nextProvider>
);

reportWebVitals();
